module.exports = __webpack_public_path__ + "img/s-mob-4.d9f98215.webp";